import { render, staticRenderFns } from "./HAddressLink.vue?vue&type=template&id=70b21621&"
import script from "./HAddressLink.vue?vue&type=script&lang=js&"
export * from "./HAddressLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports